import React, { Fragment, useState } from 'react';
import { Link } from 'react-scroll';
import config from '../../config';
import pic1 from '../assets/images/pic01.svg';
import pic2 from '../assets/images/pic02.svg';
import pic3 from '../assets/images/pic03.svg';
import pic4 from '../assets/images/pic04.png';
import pic5 from '../assets/images/pic05.png';
import pic6 from '../assets/images/pic06.png';
import pic7 from '../assets/images/pic07.jpg';
import pic8 from '../assets/images/pic08.jpg';
import pic9 from '../assets/images/pic09.jpg';
import Layout from '../components/Layout';
import Post from '../components/Post';

const IndexPage = () => {
  const [showMore, toggleShowMore] = useState(false);

  return (
    <Layout>
      <section id="banner">
        <div id="about" className="inner">
          <div className="logo">
            <span className="icon fa-diamond hidden"></span>
          </div>
          <h2>{config.heading}</h2>
          <p>{config.subHeading}</p>
        </div>
      </section>

      <section id="wrapper">
        <section className="wrapper spotlight style1">
          <div className="inner">
            <div className="image">
              <img src={pic1} alt="" />
            </div>
            <div className="content">
              <h2 className="major">Software Developer</h2>
              <p>
                Full-stack software developer with high-level proficiency in
                JavaScript (TypeScript), Python, SQL, HTML/CSS having experience
                working in teams as well as working independently in building
                web applications and data mining bots.{' '}
                <a
                  href="https://docs.google.com/document/d/1HhZ7PUWPGGMRp5v5Axkfb91HYKzzWeQgpk0zo0Vi8IU/edit?usp=sharing"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  See CV for more details
                </a>
                .
              </p>
              <Link
                to="projects"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
                className="special anchor"
              >
                See Projects
              </Link>
            </div>
          </div>
        </section>

        <section className="wrapper alt spotlight style2">
          <div className="inner">
            <div className="image">
              <img src={pic2} alt="" />
            </div>
            <div className="content">
              <h2 className="major">Technical Writer</h2>
              <p>
                Detail-oriented writer authoring top-notch articles on software
                development, programming languages, productivity tips and tricks
                for beginners, experienced developers and tech enthusiasts in a
                very easy-to-understand style.
              </p>
              <Link
                to="blog"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
                className="special anchor"
              >
                Read Blogs
              </Link>
            </div>
          </div>
        </section>

        <section className="wrapper spotlight style3">
          <div className="inner">
            <div className="image">
              <img src={pic3} alt="" />
            </div>
            <div className="content">
              <h2 className="major">Tech Volunteer</h2>
              <p>
                Mentor at{' '}
                <a
                  href="https://mentors.codingcoach.io/?name=Christian+Effiong"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Coding Coach.
                </a>{' '}
                Volunteer at{' '}
                <a
                  href="https://gracitfoundation.org"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Gracit Technological Foundation
                </a>{' '}
                to train less-privileged kids in orphanage homes on
                technological tools and skills (Scratch programming, HTML, CSS)
                to enable them secure a better future. You too can be a part of
                this,{' '}
                <a
                  href="https://gracitfoundation.org/getinvolved"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  join us today!
                </a>
              </p>
              <a
                href="https://www.instagram.com/gracitgtf"
                target="_blank"
                rel="noreferrer noopener"
                className="special"
              >
                See Photos
              </a>
            </div>
          </div>
        </section>

        <section id="projects" className="wrapper alt style1">
          <div className="inner">
            <h2 className="major">Featured Projects</h2>
            <section className="features">
              <article>
                <a
                  href="https://www.kr4all.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="image"
                >
                  <img src={pic4} alt="" />
                </a>
                <h3 className="major">KR4ALL App</h3>
                <p className="project-description">
                  A mobile healthcare app to find clinics, doctors, pharmacies
                  and emergency services near you.
                </p>
                <p className="project-role">
                  <b>Role: </b>
                  <span>Fullstack (Mobile) Developer</span>
                </p>
                <p className="project-technologies">
                  <b>Technologies: </b>
                  <span>Ionic, React, GraphQL, Hasura</span>
                </p>
                <a
                  href="https://www.kr4all.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="special link"
                >
                  View Online
                </a>
              </article>
              <article>
                <a
                  href="https://app.flipserve.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="image"
                >
                  <img src={pic5} alt="" />
                </a>
                <h3 className="major">FlipServe</h3>
                <p className="project-description">
                  FlipServe is an ISAAS company offering managed services for
                  Azure, AWS, and Google Cloud.
                </p>
                <p className="project-role">
                  <b>Role: </b>
                  <span>Fullstack Developer</span>
                </p>
                <p className="project-technologies">
                  <b>Technologies: </b>
                  <span>React, Redux, GraphQL, Hasura</span>
                </p>
                <a
                  href="https://app.flipserve.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="special link"
                >
                  View Online
                </a>
              </article>
              <article>
                <a
                  href="https://www.mahaseel.net/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="image"
                >
                  <img src={pic6} alt="" />
                </a>
                <h3 className="major">Mahaseel</h3>
                <p className="project-description">
                  Mahaseel is a agricultural products and services marketplace
                  connecting buyers and growers.
                </p>
                <p className="project-role">
                  <b>Role: </b>
                  <span>Fullstack Developer</span>
                </p>
                <p className="project-technologies">
                  <b>Technologies: </b>
                  <span>React, NodeJS, GraphQL, Hasura</span>
                </p>
                <a
                  href="https://www.mahaseel.net/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="special link"
                >
                  View Online
                </a>
              </article>
              <article>
                <a href="/#" className="image">
                  <img src={pic7} alt="" />
                </a>
                <h3 className="major">Human Capital Management</h3>
                <p className="project-description">
                  Xceed365 HCM is an enterprise HR software solution to manage
                  several HR related tasks.
                </p>
                <p className="project-role">
                  <b>Role: </b>
                  <span>Front-end Developer</span>
                </p>
                <p className="project-technologies">
                  <b>Technologies: </b>
                  <span>Angular, Ngrx, Active Directory</span>
                </p>
                <a
                  href="https://portal.xceed365.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="special link"
                >
                  View Online
                </a>
              </article>
              {showMore ? (
                <Fragment>
                  <article>
                    <a href="/#" className="image">
                      <img src={pic8} alt="" />
                    </a>
                    <h3 className="major">HomeFinder</h3>
                    <p className="project-description">
                      HomeFinder v1 is a desktop application that extracts data
                      from real estate websites.
                    </p>
                    <p className="project-role">
                      <b>Role: </b>
                      <span>Software Developer</span>
                    </p>
                    <p className="project-technologies">
                      <b>Technologies: </b>
                      <span>Python, PyQT</span>
                    </p>
                    <a href="/#" className="special link disabled">
                      View Online
                    </a>
                  </article>
                  <article>
                    <a
                      href="https://bytereads.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="image"
                    >
                      <img src={pic9} alt="" />
                    </a>
                    <h3 className="major">CodeMemoirs</h3>
                    <p className="project-description">
                      CodeMemoirs is a blog for curated articles on coding,
                      software development and more.
                    </p>
                    <p className="project-role">
                      <b>Role: </b>
                      <span>Web Developer</span>
                    </p>
                    <p className="project-technologies">
                      <b>Technologies: </b>
                      <span>Ghost, NodeJS, Linux</span>
                    </p>
                    <a
                      href="https://bytereads.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="special link"
                    >
                      View Online
                    </a>
                  </article>
                </Fragment>
              ) : null}
            </section>
            <ul className="actions">
              <li>
                <button
                  className="button outline-none"
                  onClick={() => toggleShowMore(!showMore)}
                >
                  {showMore ? 'Show Less' : 'Show More'}
                </button>
              </li>
            </ul>
          </div>
        </section>
        <section id="blog" className="wrapper style2">
          <div className="inner">
            <h2 className="major">Latest Blogs</h2>
            <section className="features">
              <Post
                title="Automatic Deployment to DigitalOcean With Github Actions"
                link="https://bytereads.com/automatic-deployment-digitalocean-github-actions/"
                picture="https://cdn.hashnode.com/res/hashnode/image/upload/v1634501167219/2rbrhOttR.png?w=1600&h=840&fit=crop&crop=entropy&auto=compress,format&format=jpeg"
                date="April 29, 2021"
              >
                Software development is a continuous process, with regular code
                updates from time to time. Whether from adding new features,
                fixing bugs or just performing general chores like updating
                project dependencies now and then.
              </Post>
              <Post
                title="How to Setup Passwordless Authentication with Auth0"
                link="https://bytereads.com/setup-passwordless-authentication/"
                picture="https://cdn.hashnode.com/res/hashnode/image/upload/v1634498600138/p1vKjm247.jpeg?w=1600&h=840&fit=crop&crop=entropy&auto=compress,format&format=jpeg"
                date="February 15, 2021"
              >
                Remembering passwords can be a pain, especially if you have to
                do that for tens or hundreds of websites and applications you
                interact with. In this article, I will show you how to set up a
                passwordless authentication flow for your web applications using
                Auth0. Trust me, your users will thank you for it.
              </Post>
            </section>
            <ul className="actions">
              <li>
                <a className="button" href="https://bytereads.com">
                  View All Posts
                </a>
              </li>
            </ul>
          </div>
        </section>
      </section>
    </Layout>
  );
};

export default IndexPage;
